import { motion } from 'framer-motion';
import { useInView } from '../../../hooks/useInView';

const StatsSection = () => {
  const [ref, isInView] = useInView({ threshold: 0.2 });

  const stats = [
    {
      number: '15+',
      label: 'Years of Excellence',
      icon: 'ri-trophy-line',
    },
    {
      number: '200+',
      label: 'Projects Completed',
      icon: 'ri-building-line',
    },
    {
      number: '50+',
      label: 'Satisfied Clients',
      icon: 'ri-user-smile-line',
    },
    {
      number: '300',
      label: 'Ton Max Capacity',
      icon: 'ri-weight-line',
    },
  ];

  return (
    <section className="py-24 bg-primary relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="stats-grid" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="white" strokeWidth="0.5"/>
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#stats-grid)" />
        </svg>
      </div>

      <div className="container mx-auto px-4 lg:px-8 relative z-10" ref={ref}>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="text-center"
            >
              <div className="w-20 h-20 bg-accent/20 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className={`${stat.icon} text-5xl text-accent`}></i>
              </div>
              <div className="text-6xl font-poppins font-black text-accent mb-3">{stat.number}</div>
              <div className="text-white/80 font-inter text-base">{stat.label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
